initSwatchColorTooltips();
// initQuickATCColorSwatchButtons();
initQuickViewButtons();
initVideoButtons();


function initVideoButtons() {
	document.addEventListener("click", e => {
		const btnVideoThumbnail = e.target.closest(".product-thumbnail-carousel__thumb-image-wrapper .btn-play-video");

		if (btnVideoThumbnail) {
			const videoWrapper = document.querySelector(".product-media-carousel .deferred-media__poster");

			if (videoWrapper) videoWrapper.click();			
		}
	});
}

function initQuickViewButtons() {
	initQuickATCButton();
	initQuickViewCloseButton();
}

function initQuickATCButton() {
	document.addEventListener("click", e => {
		const quickViewATC = e.target.closest("#Quick-view.updated button[type='submit'].product-form__btn");

		if (quickViewATC) {
			const quickViewWrapper = document.querySelector("#Quick-view .quick-view");
			const miniCartButton = document.querySelector("button[data-sidebar-button]");

			quickViewWrapper.dataset.ariaExpanded = "false";
			miniCartButton.click();
			setTimeout( () => {
				quickViewWrapper.remove();
			}, 1000);
		}
	});
}

function initQuickViewCloseButton() {
	document.addEventListener("click", e => {
		const quickViewCloseButton = e.target.closest("#Quick-view.updated .quick-view__close-button");
		const bodyOverlayElement = e.target.closest("#BodyOverlay");
		const quickViewWrapper = document.querySelector("#Quick-view .quick-view");

		if ((quickViewCloseButton || bodyOverlayElement) && quickViewWrapper) {
			quickViewWrapper.dataset.ariaExpanded = "false";
			setTimeout( () => {
				quickViewWrapper.remove();
			}, 1000);
		}

	});
}

function initSwatchColorTooltips() {
	document.addEventListener("mouseover", e => {
		const swatchColorButton = e.target.closest(".color-swatch");

		if (swatchColorButton) {
			const tooltipLabelContainer = swatchColorButton.closest(".color-swatch-select-parent");

			if (tooltipLabelContainer) {
				const tooltip = `<div class="tooltip">${tooltipLabelContainer.dataset.value}</div>`;
				const tooltipLabel = tooltipLabelContainer.querySelector(".tooltip");

				if (!tooltipLabel) swatchColorButton.insertAdjacentHTML("beforebegin", tooltip);
			}
		}
	});

	document.addEventListener("mouseout", e => {
		const swatchColorButton = e.target.closest(".color-swatch");

		if (swatchColorButton) {
			const tooltipLabel = swatchColorButton.closest(".color-swatch-select-parent .tooltip");

			if (tooltipLabel) tooltipLabel.remove();
		}
	});
}

function initQuickATCColorSwatchButtons() {
	document.addEventListener("click", e => {
		const colorSwatchButton = e.target.closest("#Quick-view .color-swatch");

		if (colorSwatchButton) {
			const selectedOption = colorSwatchButton.closest(".color-swatch-select-parent.selected");

			if (!selectedOption) {
				const quickViewWrapper = document.querySelector("#Quick-view .quick-view")?? document.querySelector("#Quick-view");
				const productHandle = colorSwatchButton.dataset.productHandle;
				const productId = colorSwatchButton.dataset.productId;
				const loadingOverlayElement = `<div class="loading-overlay product-overlay quick-view-loading"><svg class='loading-spinner' width='65px' height='65px' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'><circle stroke="currentColor" fill="none" stroke-width="3" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg></div>`;
				const newProductUrl = `https://www.southernshirt.com/products/${productHandle}`;

        // console.log({newProductUrl});
				if (quickViewWrapper) quickViewWrapper.insertAdjacentHTML("afterbegin", loadingOverlayElement);

        // debugger;

				fetch(newProductUrl)
				.then( response => {
					return response.text();
				}).then( responseHTML =>  {
					const quickViewContainer = document.querySelector("#Quick-view");
					const domParser = new DOMParser();
					const parsedHTML = domParser.parseFromString(responseHTML, 'text/html');
					const responseQuickViewElement = parsedHTML.querySelector(`div[data-quick-view-product-id='${productId}']`);

					if (quickViewContainer && responseQuickViewElement) {
						quickViewContainer.innerHTML = responseQuickViewElement.innerHTML;
						quickViewContainer.classList.add("updated");
					}
				}).catch( error => {
					console.warn('Something went wrong.', error);
				});
			}
		}
	});
}

const findSwatches = (dataUrl, productOriginalUrl) => {
  const swatches = window.document.querySelectorAll(`variant-picker[data-url="${dataUrl}"] .variant-colors-container .color-swatch[data-product-handle]`);
  if (swatches.length) {
    for(let i = 0; i < swatches.length; i++) {
      const swatch = swatches[i];
      swatch.addEventListener("click", (e) => {
      	e.preventDefault();
        e.stopImmediatePropagation();
  
        const newPath = swatch.getAttribute("data-product-handle");
        const productCard = window.document.querySelector(`product-card[data-original-url="${productOriginalUrl}"]`);
        if (productCard && newPath) {
          productCard.setAttribute("data-url", `/products/${newPath}`);
          const quickViewButton = productCard.querySelector('div[data-product-card-quick-view-button]');
          if (quickViewButton) {
            console.log("haciendo click");
            quickViewButton.click();
          }
          setTimeout(() => {
            const originalUrl = productCard.getAttribute("data-original-url");
            productCard.setAttribute("data-url", originalUrl);
          }, 150);
        }
      });
    }
  } else setTimeout(() => findSwatches(dataUrl, productOriginalUrl), 500);
}

function manageQuickViewButtons(e, productOriginalUrl){
  const closestElement = e.target.closest(`product-card[data-original-url="${productOriginalUrl}"] div[data-product-card-quick-view-button]`);
  if (closestElement) {
    const dataUrl = closestElement.closest("product-card").getAttribute("data-url");
    findSwatches(dataUrl, productOriginalUrl);
  }
}


if (window.innerWidth < 500) {
   //alert('Less than 992');
}
else {
  let timeout;
  function myFunction() {
    timeout = setTimeout(getFocus, 1500);
  }
  
  function getFocus() {
    document.getElementById("SearchSidebarForm-QueryInput-sections--17035615895604__search-sidebar").focus();
  }
}

